import { Injectable } from '@angular/core';
import { SoftwarePlatform } from '@nimmsta/ng-commons-lib/models';
import { WorkflowDataService } from '@nimmsta/ng-commons-lib/data-access';

@Injectable({
  providedIn: 'root',
})
export class SoftwarePlatformService extends WorkflowDataService<SoftwarePlatform> {
  protected override get apiEndpoint(): string {
    return '/softwarePlatforms';
  }
}
